module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "mt0 list-reset sticky-list"
  }, _vm._l((_vm.data), function(item, idx) {
    return _c('li', {
      key: item.id,
      staticClass: "mb2 sticky-item"
    }, [_c('div', {
      staticClass: "primary-info"
    }, [_c('a', {
      attrs: {
        "href": item.origin_url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "mt0 mb1 item-title",
      attrs: {
        "title": item.title,
        "data-clamp": "3"
      }
    }, [_vm._v(_vm._s(item.title))])]), _c('div', {
      staticClass: "sub"
    }, [_vm._v(_vm._s(item.pub_source)), _c('span', {
      staticClass: "px1"
    }, [_vm._v("|")]), _vm._v(_vm._s(_vm.formatUtc(item.pub_utc)))])]), _c('div', {
      staticClass: "primary-img"
    }, [_c('a', {
      attrs: {
        "href": item.origin_url,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "fit",
      attrs: {
        "src": _vm.shift(item.o_pic_list[0])
      }
    })])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6722e833","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StickyList.vue
// module id = 994
// module chunks = 1